import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import ClientsComp from './ClientsComp'

function ClientProjects() {
  return (
    <div>
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <AdmissionTopNotice/>
              <ClientsComp/>
            </div>
        </div>
    </div>
  )
}

export default ClientProjects